export default "__VITE_ASSET__BvPiybDr__"